'use strict';
const jwtModule =  require('angular-jwt');
const localForageModule = require('angular-localforage');
const ngIdleModule = require('ng-idle');
const uiRouter = require('angular-ui-router');
import {getInjectableName} from 'ng-metadata/core';
import {getSessionTimeoutParams} from '../appConfig/appConfigForward';
import {ModelService} from '../infra/dataStructures/model/model.service';
import {getUrlContext, getVid} from '../appConfig/appConfigForward';
var angular:angular.IAngularStatic =  require('angular');
import appConfigModule from '../appConfig/appConfig.module';
import {bootstrapJwt, UserSessionManagerService} from "./userSessionManager.service";
import {hcaptchaInterceptor} from "./captcha/hcaptcha.interceptor";

export default  angular.module('primo-explore.security', [jwtModule, appConfigModule.name, localForageModule, ngIdleModule, uiRouter])
    .config(Config)
    .run(Run);





function Config(IdleProvider, jwtInterceptorProvider, $httpProvider) {
    IdleProvider.interrupt('keydown mousedown');
    jwtInterceptorProvider.tokenGetter = getJwtToken;
    $httpProvider.interceptors.push(skipJwt);
    $httpProvider.interceptors.push('jwtInterceptor'); // --> Sending jwt in each request
    $httpProvider.interceptors.push(prmInterceptor);
    $httpProvider.interceptors.push(responseErrorInterceptor);
    $httpProvider.interceptors.push(addToRequestInterceptor);
    $httpProvider.interceptors.push(handleSlimRequestInterceptor);
    $httpProvider.interceptors.push(hcaptchaInterceptor);
    //$httpProvider.interceptors.push(aPIInterceptorProvider);

    function skipJwt(){
        return {
            request: (request)=> {
                if(!(request.url.includes('primo_library/libweb') || request.url.includes('/primaws/rest') || request.url.includes('/primaws/suprimaLogout'))) {
                    request.skipAuthorization = true;
                }
                return request;
            }
        };
    }

    function prmInterceptor(modelService){

        var service = {

            response: function (response){

                if(modelService.active) {
                    let model = modelService.modelInstance;
                    if (response.config.url.indexOf('/rest/') > -1) {
                        let key = modelService.getKey(response.config.url);
                        modelService.addToModel(key, response);
                    }
                }

                return response;
            }
        };

        return service;
    }

    prmInterceptor.$inject = [getInjectableName(ModelService)];


    function responseErrorInterceptor($injector, $q: ng.IQService) {
        return {
            responseError: function (response) {
                switch (response.status) {
                    case 401:
                        if (response.headers('invalid_jwt') != null) { //if response came from WsXsIpFilter.java then perform logout
                            let userSessionManager: UserSessionManagerService = $injector.get(getInjectableName(UserSessionManagerService));
                            userSessionManager.logout(true);
                        }
                }
                return $q.reject(response);
            }
        }
    }

    responseErrorInterceptor.$inject = ['$injector', '$q'];


    function addToRequestInterceptor(i18nService) {
        var service = {

            request: function (request){
                if(request.url.includes('primaws/') || request.url.includes('primo_library/libweb')) {
                    if (request.url.includes('primaws/') && !request.params) {
                        request.params = {}; //so every request in PrimoVE gets lang param
                    }
                    if (request.params && !request.params.lang && i18nService.getLanguage()) {
                        request.params.lang = i18nService.getLanguage();
                    }

                }

                return request;
            }
        };

        return service;
    }

    addToRequestInterceptor.$inject = ['I18nService'];

    function handleSlimRequestInterceptor($q) {
        return {
            request: function (request) {
                const slimSEO = new URLSearchParams(window.location.search).get('slimSEO');
                if(slimSEO === 'true') {
                    const allowedUrls = ['/pnxs', '/configuration', '/translations', '/guestJwt','/dummy'];
                    if(request.url.includes('/primaws') && !allowedUrls.some(allowedUrl => request.url.includes(allowedUrl)) ) {
                        console.log('Rejecting the request: ' + request.url);
                        return $q.reject({
                            status: 403,
                            message: 'Request is rejected.'
                        });
                    }
                }

                return request;
            }
        };
    }

    handleSlimRequestInterceptor.$inject = ['$q'];

}
Config.$inject = ['IdleProvider', 'jwtInterceptorProvider', '$httpProvider'];




function getJwtToken(userSessionManagerService) {
    // Try immediately
    const now = userSessionManagerService.getJwt();
    if (now) return now;

    // Wait for cross-tab sync barrier
    return userSessionManagerService.whenJwtSyncReady().then(() => {
        const after = userSessionManagerService.getJwt();
        if (after) return after;

        // Still nothing? Use the guest bootstrap promise
        return bootstrapJwt();
    });
}

getJwtToken.$inject = [getInjectableName(UserSessionManagerService)];



function Run(userSessionManagerService, $http, $location) {
    if($location.absUrl().indexOf('debugmode=true') > -1){
        $http.defaults.headers.common['explore-debug-mode'] = '1';
    }

    try {
        // Skip the silent-login iframe entirely
        if (window.name === 'primo-silent-login') {
            console.log('[Run] Skipping runStartupCode inside silent-login iframe');
            return;
        }
    } catch (_) {}

    userSessionManagerService.runStartupCode();
}

Run.$inject = [ getInjectableName(UserSessionManagerService), '$http', '$location'];
import './sessionTimeout.service';





// WEBPACK FOOTER //
// ./src/main/webapp/components/security/security.module.ts